<div class="page-wrapper">
    <div class="content container-fluid">
        

        <div class="row">
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">Room Equiry</h4>
                </div>
                <form [formGroup]="form" (ngSubmit)="onSubmit()">
                <div class="card-body">
                    <div class="row">
                        
                        <div class="col-md-6">
                            <div class="card border">

                                <div class="form-check form-check-inline text-center p-3" >
                                    <h4 class="card-title pb-2">Booking Type</h4>
                                    <input type="radio" class="btn-check" formControlName="bookingype" value="Daily"  id="radiodaily" (click)="onbookingtypeClick()"  autocomplete="off">
                                    <label class="btn btn-warning btn-re" for="radiodaily"> Daily</label> &nbsp;
                                    <input type="radio" class="btn-check" formControlName="bookingype" value="Monthly"   id="radiomonthly" (click)="onbookingtypeClick()"  autocomplete="off">
                                    <label class="btn btn-warning btn-re" for="radiomonthly">Monthly</label>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="card border">
                                <div class="form-check form-check-inline text-center p-3">
                                    <h4 class="card-title pb-2">Category Rooms</h4>
                                    <span *ngFor="let categoryitem of resprolesData">
                                    <input type="radio" class="btn-check"  formControlName="roomcategytype"  id="radio{{categoryitem.RoomcategoryId}}" value="{{categoryitem.CategoryName}}" (click)="oncategoryroomsClick(categoryitem.RoomcategoryId)" autocomplete="off">
                                    <label class="btn btn-warning btn-re" for="radio{{categoryitem.RoomcategoryId}}">{{categoryitem.CategoryName}}</label>&nbsp;
                                    </span>
                                    <!-- <input type="radio" class="btn-check" name="optionsac" id="radiononac" autocomplete="off">
                                    <label class="btn btn-warning btn-re" for="radiononac">NON - AC</label> -->
                                </div>
                            </div>

                        </div>

                    </div>
                    <div class="row" *ngIf="isroomtypes">
                        <div class="col-md-12">
                            <div class="card border">

                                <div class="form-check form-check-inline text-center p-3">
                                    <h4 class="card-title pb-3">Room types</h4>
                                    <span *ngFor="let roomtypeitem of resproomtypesData">
                                    <input  type="radio"  class="btn-check" formControlName="typesofrooms"  value="{{roomtypeitem.RoomTypeName}}"   id="radioroomt{{roomtypeitem.Roomtypeid}}" (click)="onroomtypeClick(roomtypeitem.TypeAmount)" autocomplete="off">
                                    <label class="btn btn-warning btn-re " for="radioroomt{{roomtypeitem.Roomtypeid}}"> {{roomtypeitem.RoomTypeName}}</label>&nbsp;
                                </span>
                                    
                                    <!-- <input type="radio" class="btn-check" name="options" id="radio1" autocomplete="off">
                                    <label class="btn btn-warning btn-re " for="radio1">2-Share</label>&nbsp;
                                    <input type="radio" class="btn-check" name="options" id="radio2" autocomplete="off">
                                    <label class="btn btn-warning btn-re " for="radio2">3-Share</label>&nbsp;
                                    <input type="radio" class="btn-check" name="options" id="radio3" autocomplete="off">
                                    <label class="btn btn-warning btn-re " for="radio3">4-Share</label>&nbsp;
                                    <input type="radio" class="btn-check" name="options" id="radio4" autocomplete="off">
                                    <label class="btn btn-warning btn-re " for="radio4">5-Share</label> -->
                                </div>
                            </div>
                        </div>


                        <div class="row ">
                            <div class="col-md-6">
                                <div class="p-3">
                                    <h4 class="card-title pb-2"> Base Amenities</h4>


                                    <div class="input-group mb-3"  *ngFor="let baseamenitiitem of respbybaseeminity">
                                        <span class="text-wrap">{{baseamenitiitem.FacilityName}}</span>
                                    </div>

                                    <!-- <div class="input-group mb-3">

                                        <span class="text-wrap">Bed &amp; Mattress</span>
                                    </div>

                                    <div class="input-group mb-3">

                                        <span class="text-wrap">CC cameras</span>
                                    </div> -->
                                </div>
                            </div>


                            <div class="col-md-6">
                                <div class="p-3">
                                    <h4 class="card-title pb-2"> Extra Amenities</h4>

                                    <div class="input-group mb-3" *ngFor="let extraamenitiitem of respbyDatasss">
                                        <div class="input-group-text">
                                            <input class="form-check-input mt-0" type="checkbox" value="{{extraamenitiitem.Amount}}" aria-label="Checkbox for following text input" (change)="setAll($event,extraamenitiitem.FacilityID)">
                                        </div>

                                        <span class="Text input with checkbox p-2">{{extraamenitiitem.FacilityName}} <span class="text-wrap" style="width: 2rem;">{{extraamenitiitem.Amount}}</span></span>
                                    </div>
                                    <!-- <div class="input-group mb-3">
                                        <div class="input-group-text">
                                            <input class="form-check-input mt-0" type="checkbox" value="" aria-label="Checkbox for following text input">
                                        </div>

                                        <span class="Text input with checkbox p-2">Mineral water</span>
                                    </div>

                                    <div class="input-group mb-3">
                                        <div class="input-group-text">
                                            <input class="form-check-input mt-0" type="checkbox" value="" aria-label="Checkbox for following text input">
                                        </div>

                                        <span class="Text input with checkbox p-2">Washing Machine</span>
                                    </div> -->



                                </div>
                            </div>




                        </div>

                        <div class="col-md-12">
                            <div class="p-3">
                                <!-- <div class="col-md-6">
                                    <div class="input-group mb-3">
                                        <label class="col-lg-4 col-form-label">No. Of Guests</label>
                                        <div class="col-lg-8">
                                            <input type="text" class="form-control" formControlName="noofguests" >
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="input-group mb-3">
                                        <label class="col-lg-4 col-form-label">No. Of Months</label>
                                        <div class="col-lg-8">
                                            <input type="text" class="form-control" formControlName="noofmonths">
                                        </div>
                                    </div>
                                </div> -->
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="input-group mb-3">
                                            <label class="col-lg-4 col-form-label">Booking Price</label>
                                            <div class="col-lg-8">

                                                <label class="col-form-label font-weight-600" >{{bookingprice}}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="input-group mb-3">
                                            <label class="col-lg-4 col-form-label">Final Price:</label>
                                            <div class="col-lg-8">

                                                <label class="col-form-label font-weight-600">{{finalprice + extraamounts}}</label>
                                            </div>
                                        </div>
                                    </div>



                                    <div class="col-md-12">
                                        <p style="font-size: 13px">For Monthly Bookings Security Deposit and any other Applicable extra amounts need to be paid at the time of check-in</p>
                                    </div>
                                </div>
                                <hr />
                                <div class="col-md-12">
                                    <div class="form-group row">
                                        <div class="text-center">
                                            <button class="btn btn-warning btn-sm" type="submit">CONTINUE</button>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>




                    </div>




                </div>
            </form>
            </div>
        </div>
        <div id="overlay" [style.display]="this.showOverlay" *ngIf="isLoading">
            <div id="overlay-spinner">
              <mat-spinner [diameter]="150"></mat-spinner>
            </div><br />
            <div id="overlay-text">
              <span>Loading ...</span>
            </div>
          </div>

    </div>
</div>

